import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getJiraStatuses } from '@api';

export const getJiraStatusesSlice = createGetAsyncSlice({
	name: 'jiraStatuses',
	receive: true,
	request: false,
	requestHandler: getJiraStatuses,
	retainDataOnRequest: true
});
